import { Link } from 'react-router-dom';
import Logo from '@/components/layout/Logo/Logo';
import { useScrolled } from '@/hooks/useScrolled';
import { SERVICE_FULL_NAME } from '@/lib/brand';
import styles from './SiteHeader.module.css';

type Variant = 'lp' | 'app';

type Props = {
  variant?: Variant;
  /** app 変種でロゴ＝ホームを押したときの挙動。渡すとロゴは「最初に戻る」ボタンになる
   *  （結果のクリアなどは呼び出し側が担う）。未指定ならロゴは通常のリンク。 */
  onHome?: () => void;
  /** ヒーローに重ねて置く（LP）。最上部では透過＋白ロゴ、スクロールすると白地に戻る。
   *  直後の要素がヘッダーの高さぶん上に潜り込む前提（.hero の負の margin-top）。 */
  overlay?: boolean;
};

const LP_NAV = [
  { href: '#how', label: '使い方' },
  { href: '#report', label: '何がわかる？' },
  { href: '#marks', label: '判定の見方' },
  { href: '#faq', label: 'よくある質問' },
];

export default function SiteHeader({ variant = 'lp', onHome, overlay = false }: Props) {
  const scrolled = useScrolled(24);
  const atTop = overlay && !scrolled;
  const logo = <Logo variant={atTop ? 'reversed' : 'horizontal'} />;

  return (
    <header className={`${styles.header} ${atTop ? styles.atTop : ''}`}>
      {/* ツール画面のロゴは LP に戻さず、押すと最初の検索画面へリセットする操作（=ボタン）。
          それ以外（サンプル・LP・404）は遷移リンク。 */}
      {variant === 'app' && onHome ? (
        <button
          type="button"
          onClick={onHome}
          className={styles.brand}
          aria-label={`${SERVICE_FULL_NAME} ホーム`}
        >
          {logo}
        </button>
      ) : (
        <Link
          to={variant === 'app' ? '/report' : '/'}
          className={styles.brand}
          aria-label={`${SERVICE_FULL_NAME} ホーム`}
        >
          {logo}
        </Link>
      )}

      {variant === 'lp' && (
        <nav className={styles.nav} aria-label="メイン">
          <span className={styles.navLinks}>
            {LP_NAV.map((item) => (
              <a key={item.href} href={item.href} className={styles.navLink}>
                {item.label}
              </a>
            ))}
          </span>
          <Link to="/report" className={styles.cta}>
            <span className={styles.ctaFull}>無料で調べる</span>
            <span className={styles.ctaShort}>調べる</span>
          </Link>
        </nav>
      )}
    </header>
  );
}
